import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, FormGroup, Row, Col } from "reactstrap";
import { Formik, Field, Form } from "formik";
import { toast } from "react-toastify";
import moment from "moment";
import API from "utils/API";
import Loader from "components/Loader";
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikCheckboxField from "components/common/Fields/FormikCheckboxField";
import { currencyFormat } from "utils/columns";

const NPIPorviderEdit = ({
  tenantID,
  coveredEntityID,
  providerId,
  onClose,
}) => {
  const [provider, setProvider] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchProviderById = async () => {
    try {
      setLoading(true);
      const { data } = await API.get(
        `/${tenantID}/ceprovider/get/${coveredEntityID}/${providerId}`
      );
      setProvider(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error  ====>> ", error);
    }
  };

  useEffect(() => {
    fetchProviderById();
  }, []);

  if (loading) return <Loader opacity={0.1} color="black" />;

  const {
    providerFirstName,
    providerLastName,
    comments,
    faxNumber,
    providerSpecialty,
    opportunityAmount,
    opportunityCount,
    providerNPI,
    eligibleFlag,
    suppressFlag,
    source,
    createdBy,
    createdDate,
    modifiedBy,
    modifiedDate,
  } = provider;

  const dateFormatter = (date) => {
    if (date) return moment(date).format("MM/DD/YYYY");
    return "-";
  };

  const initialValues = {
    providerNPI: providerNPI || "",
    providerFirstName: providerFirstName || "",
    providerLastName: providerLastName || "",
    eligibleFlag: eligibleFlag || "",
    suppressFlag: suppressFlag === "Y" ? true : false,
    comments: comments || "",
    faxNumber: faxNumber || "",
    providerSpecialty: providerSpecialty || "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = { ...provider, ...values };
    payload.eligibleFlag = values.eligibleFlag === true ? "Y" : "N";
    payload.suppressFlag = values.suppressFlag === true ? "Y" : "N";
    try {
      await API.post(`/${tenantID}/CEProvider/update`, payload);
      toast.success("Updated Successfully!");
      setSubmitting(false);
      onClose(true);
    } catch (error) {
      setSubmitting(false);
      toast.error("An error occurred");
    }
  };

  return (
    <Card className="border-0 rounded shadow-top">
      <CardBody>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={handleSubmit}
          children={({ values, isSubmitting }) => {
            return (
              <Form>
                {isSubmitting && <Loader opacity={0.01} color="black" />}
                <Row>
                  <Col sm="6">
                    <FormGroup>
                      <Field
                        key="providerFirstName"
                        id="providerFirstName"
                        name="providerFirstName"
                        type="text"
                        component={FormikInputField}
                        label="Provider First Name"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Field
                        key="providerLastName"
                        id="providerLastName"
                        name="providerLastName"
                        type="text"
                        component={FormikInputField}
                        label="Provider Last Name"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col sm="6">
                    <FormGroup>
                      <Field
                        key="comments"
                        id="comments"
                        name="comments"
                        type="textarea"
                        component={FormikInputField}
                        label="Comments"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Field
                        key="faxNumber"
                        id="faxNumber"
                        name="faxNumber"
                        type="text"
                        component={FormikInputField}
                        label="Fax Number"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <FormGroup>
                      <Field
                        key="providerSpecialty"
                        id="providerSpecialty"
                        name="providerSpecialty"
                        type="text"
                        component={FormikInputField}
                        label="Provider Specialty"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6">
                    <FormGroup>
                      {eligibleFlag ? (
                        <p className="f-14 mb-0">
                          Eligible Flag:
                          <b className="d-inline-block ps-2 font-weight-500">
                            {eligibleFlag || "-"}
                          </b>
                        </p>
                      ) : (
                        <Field
                          key="eligibleFlag"
                          id="eligibleFlag"
                          name="eligibleFlag"
                          type="checkbox"
                          component={FormikCheckboxField}
                          label="Eligible Flag"

                        />
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Field
                        key="suppressFlag"
                        id="suppressFlag"
                        name="suppressFlag"
                        type="checkbox"
                        component={FormikCheckboxField}
                        label=" Suppress Flag"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="align-items-center mb-2">
                  <Col sm="6">
                    <FormGroup>
                      <p className="f-14 mb-0">
                        Source:
                        <b className="d-inline-block ps-2 font-weight-500">
                          {source || "-"}
                        </b>
                      </p>
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="align-items-center mb-2">
                  <Col sm="6">
                    <FormGroup>
                      <p className="f-14 mb-0">
                        Opportunity Amount:
                        <b className="d-inline-block ps-2 font-weight-500">
                          {currencyFormat(opportunityAmount) || "-"}
                        </b>
                      </p>
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <p className="f-14 mb-0">
                        Opportunity Count:
                        <b className="d-inline-block ps-2 font-weight-500">
                          {opportunityCount || "-"}
                        </b>
                      </p>
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="align-items-center mb-2">
                  <Col sm="6">
                    <FormGroup>
                      <p className="f-14 mb-0">
                        Created By:
                        <b className="d-inline-block ps-2 font-weight-500">
                          {createdBy || "-"}
                        </b>
                      </p>
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <p className="f-14 mb-0">
                        Created Date:
                        <b className="d-inline-block ps-2 font-weight-500">
                          {dateFormatter(createdDate) || "-"}
                        </b>
                      </p>
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="align-items-center mb-2">
                  <Col sm="6">
                    <FormGroup>
                      <p className="f-14 mb-0">
                        Modified By:
                        <b className="d-inline-block ps-2 font-weight-500">
                          {modifiedBy || "-"}
                        </b>
                      </p>
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <p className="f-14 mb-0">
                        Modified Date:
                        <b className="d-inline-block ps-2 font-weight-500">
                          {dateFormatter(modifiedDate) || "-"}
                        </b>
                      </p>
                    </FormGroup>
                  </Col>
                </Row>

                <div className="d-flex justify-content-end align-items-center">
                  <div>
                    <Button
                      color="primary"
                      type="submit"
                      size="sm"
                      disabled={isSubmitting}
                    >
                      Update
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        ></Formik>
      </CardBody>
    </Card>
  );
};

export default NPIPorviderEdit;
